/* eslint-disable max-len */
import React, { useContext,useEffect, useRef, useState } from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import DateInputStatic from '../../../../components/DateField/staticdate';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { setDeviceAlertDashboardSearch,resetDeviceAlertDashboardSearch } from '../../../../redux/deviceAleartDashboardSlice';
import DateInput from '../../../../components/DateField/staticdate';
import Dropdown from '../../../../components/Dropdown';

export default function DeviceAlertDashboardSearch({handleOnSubmit,emptyField,setEmptyField,orgCorpAndMonitorSearch,orgPatientSearch,DeviceReadingList}) {
    const deviceDashboardSearch = useSelector(state => state.deviceAlertDashboardSearchData);
    const searchApplied = useSelector((state) => state.deviceAlertDashboardSearchData.deviceAlertDashboardSearchApplied);
    const {isSideBar,setIsSideBar,isSearchOpen,setIsSearchOpen} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()
    const btnRef = useRef(null);


    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;
        // Allow only numeric input for the "age" field
        if (id === 'age') {
        // Use a regular expression to allow only numbers
            updatedValue = updatedValue.replace(/\D/g, ''); // Removes any non-numeric characters
        }
        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue;
        }
    
        const updatedState = { ...deviceDashboardSearch, [id]: updatedValue };
    
        // Handle special cases for username and email
        if (['user_name', 'user_name_domain'].includes(id)) {
            const isUserNameEmpty = updatedState.user_name === '' && updatedState.user_name_domain === '';
            if (isUserNameEmpty) updatedState.user_name_inverse = '';
        }
        if (['email_address', 'email_address_domain'].includes(id)) {
            const isEmailEmpty = updatedState.email_address === '' && updatedState.email_address_domain === '';
            if (isEmailEmpty) updatedState.email_address_inverse = '';
        }

        // General case for other fields
        if (updatedValue === '' && updatedState[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
    
        // Update the deviceDashboardSearch state and dispatch to Redux
        setDeviceAlertDashboardSearch(updatedState);
        dispatch(setDeviceAlertDashboardSearch(updatedState));
    };

    //handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;
    
        // Create an updated deviceDashboardSearch state
        let updatedState = { ...deviceDashboardSearch };
    
        if (field === 'ne:__NULL__' || field === '__NULL__') {
            // Update the status array if it's a status-related checkbox
            const updatedStatus = checked 
                ? [...(deviceDashboardSearch.acknowledged_id || []), field] 
                : (deviceDashboardSearch.acknowledged_id || []).filter((acknowledged_id) => acknowledged_id !== field);
    
            // Uncheck status_inverse if the status array is empty
            if (updatedStatus.length === 0) {
                updatedState.acknowledged_id_inverse = '';
            }
    
            updatedState.acknowledged_id = updatedStatus;
        } else {
            // Handle other fields as boolean values
            updatedState[field] = checked ? 'true' : '';
        }
    
        // Dispatch the updated state
        dispatch(setDeviceAlertDashboardSearch(updatedState));
    };

    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);

    const handleDateChange = (newDate) => {
        setEmptyField(false);
    
        // Validate input: allow numbers and dashes, and apply limits
        // Allow any combination of numbers and dashes in each field, and apply limits only if no dash is present
        const validatedDay = /^[-0-9]*$/.test(newDate.day) && 
                (newDate.day.includes('-') || (newDate.day.length <= 2 && parseInt(newDate.day) <= 31)) 
            ? newDate.day 
            : '';
        
        const validatedMonth = /^[-0-9]*$/.test(newDate.month) && 
                (newDate.month.includes('-') || (newDate.month.length <= 2 && parseInt(newDate.month) <= 12)) 
            ? newDate.month 
            : '';
        
        const validatedYear = /^[-0-9]*$/.test(newDate.year) && 
                (newDate.year.includes('-') || newDate.year.length <= 4) 
            ? newDate.year 
            : '';
    
        // Check if the date is fully cleared
        const isDateCleared =
            (!validatedDay.trim() || validatedDay === '-') &&
            (!validatedMonth.trim() || validatedMonth === '-') &&
            (!validatedYear.trim() || validatedYear === '-');
    
        dispatch(setDeviceAlertDashboardSearch({
            ...deviceDashboardSearch,
            measurement_day: validatedDay,
            measurement_month: validatedMonth,
            measurement_year: validatedYear,
            // Uncheck the checkbox if the date fields are cleared
            measurement_date_inverse: isDateCleared ? '' : deviceDashboardSearch.measurement_date_inverse,
        }));
    };

    // Function to handle button click
    const handleCloseClick = () => {
        // Toggle the advanced search state
        setIsSearchOpen(!isSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {            
            dispatch(resetDeviceAlertDashboardSearch());
        }
    };

    const isApplyButtonDisabled = () => {
        return Object.entries(deviceDashboardSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };
    const params = new URLSearchParams(searchParams);

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        if (btnRef.current) {
            btnRef.current.disabled = true; // Disable the button
        }

        dispatch(resetDeviceAlertDashboardSearch());

        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');

        setTimeout(() => {
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);

            if (btnRef.current) {
                btnRef.current.disabled = false; // Re-enable after operation
            }
        }, 300);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleClearAll]);

    useEffect(() => {      
        dispatch(resetDeviceAlertDashboardSearch())  
                
        const params = Object.fromEntries(searchParams);

        if (params.search) {
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
                   
            // Existing matches for patient_id, age, alert_title and other states
            const patIdMatch = searchDecoded.match(/(patient_id|patient_name)=(ne:)?(.+?)(;|$)/);
            const ageMatch = searchDecoded.match(/age=(ne:)?(.+?)(;|$)/);
            const alertTitleMatch = searchDecoded.match(/alert_title=(ne:)?(.+?)(;|$)/);
            const alertMessageMatch = searchDecoded.match(/alert_message=(ne:)?(.+?)(;|$)/);
            const userIdMatch = searchDecoded.match(/(sender_user_id|created_by)=(ne:)?(.+?)(;|$)/);
            const organizationIdMatch = searchDecoded.match(/organization_id=(ne:)?(.+?)(;|$)/);
            const deviceAcknowledgeMatch = searchDecoded.match(/acknowledged_by=(ne:)?(.+?)(;|$)/);
            const providerIdMatch = searchDecoded.match(/acknowledged_by=(ne:)?(.+?)(;|$)/);
            const acknowledgeDateMatch = searchDecoded.match(/acknowledged_at=(ne:)?(\d+)(;|$)/);
            const alertPriorityMatches = searchDecoded.match(/alert_priority=(ne:)?([^;]+)/g);
            const deviceIdMatch = searchDecoded.match(/device_id=(ne:)?(.+?)(;|$)/);
            const alertTypeMatch = searchDecoded.match(/alert_type=(ne:)?(.+?)(;|$)/);
            const readingTypeMatch = searchDecoded.match(/reading_details=(ne:)?(.+?)(;|$)/);

            // Build the new state
            const updatedState = {};
                   
            // handle patient_id field
            if (patIdMatch) {
                const isInverse = !!patIdMatch[2]; // Check if `ne:` is present
                const fieldValue = patIdMatch[3]; // Extract the value
            
                // Update the shared state fields
                updatedState.patient_id = fieldValue === '__NULL__' ? '-' : fieldValue;
                updatedState.patient_inverse = isInverse ? 'true' : '';
            }
                
            // Handle alertTypeMatch field
            if (alertTypeMatch) {
                const isInverse = !!alertTypeMatch[1];
                const alertTypeValue = alertTypeMatch[2];
                updatedState.alert_type = alertTypeValue === '__NULL__' ? '-' : alertTypeValue;
                updatedState.alert_type_inverse = isInverse ? 'true' : '';
            }

            // Handle readingTypeMatch field
            if (readingTypeMatch) {
                const isInverse = !!readingTypeMatch[1];
                const readingTypeValue = readingTypeMatch[2];
                updatedState.reading_details = readingTypeValue === '__NULL__' ? '-' : readingTypeValue;
                updatedState.reading_details_inverse = isInverse ? 'true' : '';
            }

            // Handle age field
            if (ageMatch) {
                const isInverse = !!ageMatch[1];
                const ageValue = ageMatch[2];
                updatedState.age = ageValue === '__NULL__' ? '-' : ageValue;
                updatedState.age_inverse = isInverse ? 'true' : '';
            }

            // Handle age field
            if (deviceIdMatch) {
                const isInverse = !!deviceIdMatch[1];
                const deviceIdValue = deviceIdMatch[2];
                updatedState.device_id = deviceIdValue === '__NULL__' ? '-' : deviceIdValue;
                updatedState.device_id_inverse = isInverse ? 'true' : '';
            }
            
            // Handle alert_title field
            if (alertTitleMatch) {
                const isInverse = !!alertTitleMatch[1];
                const lastNameValue = alertTitleMatch[2];
                updatedState.alert_title = lastNameValue === '__NULL__' ? '-' : lastNameValue;
                updatedState.alert_title_inverse = isInverse ? 'true' : '';
            }
            
            // Handle alertMessageMatch field
            if (alertMessageMatch) {
                const isInverse = !!alertMessageMatch[1];
                const alertMessageValue = alertMessageMatch[2];
                updatedState.alert_description = alertMessageValue === '__NULL__' ? '-' : alertMessageValue;
                updatedState.alert_description_inverse = isInverse ? 'true' : '';
            }

            // Handle userIdMatch field
            if (userIdMatch) {
                const isInverse = !!userIdMatch[2]; // Check if `ne:` is present
                const fieldValue = userIdMatch[3]; // Extract the value

                updatedState.user_id = fieldValue === '__NULL__' ? '-' : fieldValue;
                updatedState.user_id_inverse = isInverse ? 'true' : '';

            }

            // Handle providerIdMatch field
            if (providerIdMatch) {
                const isInverse = !!providerIdMatch[1];
                const providerIdValue = providerIdMatch[2];  
                updatedState.provider_id = providerIdValue === '__NULL__' ? '-' : providerIdValue;
                updatedState.provider_id_inverse = isInverse ? 'true' : '';
                            
            }
            if(params.tab==='device_alert'){
                if (deviceAcknowledgeMatch) {
                    const isInverse = !!deviceAcknowledgeMatch[1];
                    const deviceAcknowledgeValue = deviceAcknowledgeMatch[2];
                    updatedState.user_id = deviceAcknowledgeValue === '__NULL__' ? '-' : deviceAcknowledgeValue;
                    updatedState.user_id_inverse = isInverse ? 'true' : '';
                }
            }
            
            // Handle organizationIdMatch field
            if (organizationIdMatch) {
                const isInverse = !!organizationIdMatch[1];
                const orgIDValue = organizationIdMatch[2];
                updatedState.organization_id = orgIDValue === '__NULL__' ? '-' : orgIDValue;
                updatedState.organization_id_inverse = isInverse ? 'true' : '';
            }

            if (alertPriorityMatches) {
                const alertPriorities = alertPriorityMatches.map((match) => {
                    // Extract the `ne:` prefix and the value
                    const [, isInverse, priorityValue] = match.match(/alert_priority=(ne:)?(.+)/) || [];
                    return {
                        value: priorityValue === '__NULL__' ? '-' : decodeURIComponent(priorityValue),
                        isInverse: !!isInverse, // true if `ne:` is present
                    };
                });
            
                // Extract values into updatedState
                updatedState.alert_severity = alertPriorities.map((item) => item.value).join('; '); // Combine priorities
                updatedState.alert_severity_inverse = alertPriorities.some((item) => item.isInverse) ? 'true' : '';
            }

            // Handle assigned date field
            if (acknowledgeDateMatch) {
                const isInverse = !!acknowledgeDateMatch[1]; 
                const epochTime = acknowledgeDateMatch[2]; 
                            
                // Convert epoch time to a date
                const date = new Date(parseInt(epochTime, 10) * 1000); 
                            
                // Use getDate(), getMonth(), and getFullYear() for local time
                const day = date.getDate().toString().padStart(2, '0'); // Ensure day is two digits
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure month is two digits
                const year = date.getFullYear().toString(); 
                            
                // Update state with the correct date and inverse flag
                updatedState.measurement_day = day;
                updatedState.acknowledge_month = month;
                updatedState.acknowledge_year = year;
                updatedState.acknowledge_date_inverse = isInverse ? 'true' : ''; 
            }
                    
            // Handle search_mode if applicable
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or' ? true : false;
            }
            
            // Dispatch the action to update Redux state
            dispatch(setDeviceAlertDashboardSearch(updatedState));
        }
    }, [isSearchOpen]);

    return (
        <div className='fixed top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={deviceDashboardSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${deviceDashboardSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!deviceDashboardSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!deviceDashboardSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[9999]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        {!DeviceReadingList &&
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div id="date" className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={'Timestamp'}
                                    date={{
                                        day: deviceDashboardSearch.measurement_day,
                                        month: deviceDashboardSearch.measurement_month,
                                        year: deviceDashboardSearch.measurement_year,
                                    }}
                                    onDateChange={handleDateChange}
                                    dateFormat={dateFormat}
                                    idPrefix="measurement"
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2  relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='measurement_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'measurement_date_inverse')}
                                        checked={deviceDashboardSearch.measurement_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.measurement_day?.trim()==="" || deviceDashboardSearch?.measurement_month?.trim()==="" || deviceDashboardSearch?.measurement_year?.trim()===""}
                                    />
                                    <label htmlFor='measurement_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        }
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <Dropdown
                                    label={"Reading Type"}
                                    id={"reading_type"}
                                    placeholder={deviceDashboardSearch.reading_type.length > 0 ? '' : 'Select reading type'}
                                    data_testid={"reading_type"}
                                    value={deviceDashboardSearch?.reading_type}
                                    options={['Blood Glucose', 'Blood Pressure', 'SPO2', 'Weight', 'Pulse', 'Temperature']}
                                    handleOnChangeInput={handleOnChangeUserDetails}   
                                    searchDropdown={true}  
                                />     
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='reading_type_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'reading_type_inverse')}
                                        checked={deviceDashboardSearch?.reading_type_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.reading_type.trim()==='' || deviceDashboardSearch?.reading_type.trim()===undefined}
                                    />
                                    <label htmlFor='reading_type_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div> 
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Reading"}
                                    placeholder={"Enter reading"}
                                    id={"reading"}
                                    data_testid={"reading"}
                                    htmlFor={"reading"} 
                                    value={deviceDashboardSearch?.reading}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='reading_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'reading_inverse')}
                                        checked={deviceDashboardSearch?.reading_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.reading?.trim()==='' || deviceDashboardSearch?.reading?.trim()===undefined}
                                    />
                                    <label htmlFor='reading_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <Dropdown
                                    label={"Alert Type"}
                                    id={"alert_type"}
                                    placeholder={deviceDashboardSearch.alert_type.length > 0 ? '' : 'Select alert type'}
                                    data_testid={"alert_type"}
                                    value={deviceDashboardSearch?.alert_type}
                                    options={DeviceReadingList?['Threshold Exceeding']:['Missed Reading','Threshold Exceeding']}
                                    handleOnChangeInput={handleOnChangeUserDetails}   
                                    searchDropdown={true}  
                                />     
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='alert_type_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'alert_type_inverse')}
                                        checked={deviceDashboardSearch?.alert_type_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.alert_type.trim()==='' || deviceDashboardSearch?.alert_type.trim()===undefined}
                                    />
                                    <label htmlFor='alert_type_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <Dropdown
                                    label={"Reading Details"}
                                    id={"reading_details"}
                                    placeholder={deviceDashboardSearch.reading_details.length > 0 ? '' : 'Select reading details'}
                                    data_testid={"reading_details"}
                                    value={deviceDashboardSearch?.reading_details}
                                    options={DeviceReadingList ? ['Too High','Too Low','Too High/Too High','Too Low/Too Low','Too High/Too Low','Too Low/Too High'] : ['Missed Reading','Too High','Too Low','Too High/Too High','Too Low/Too Low','Too High/Too Low','Too Low/Too High']}
                                    handleOnChangeInput={handleOnChangeUserDetails}   
                                    searchDropdown={true}  
                                />     
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='reading_details_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'reading_details_inverse')}
                                        checked={deviceDashboardSearch?.reading_details_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.reading_details.trim()==='' || deviceDashboardSearch?.reading_details.trim()===undefined}
                                    />
                                    <label htmlFor='reading_details_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>  
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Threshold"}
                                    placeholder={"Enter threshold"}
                                    id={"threshold"}
                                    data_testid={"threshold"}
                                    htmlFor={"threshold"}
                                    value={deviceDashboardSearch?.threshold}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='threshold_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'threshold_inverse')}
                                        checked={deviceDashboardSearch?.threshold_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.threshold?.trim()==="" || deviceDashboardSearch?.threshold?.trim()===undefined}
                                    />
                                    <label htmlFor='threshold_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Device ID"}
                                    placeholder={"Enter device ID"}
                                    id={"device_id"}
                                    data_testid={"device_id"}
                                    htmlFor={"device_id"}
                                    value={deviceDashboardSearch?.device_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='device_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'device_id_inverse')}
                                        checked={deviceDashboardSearch?.device_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={deviceDashboardSearch?.device_id?.trim()===""}
                                    />
                                    <label htmlFor='device_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {!DeviceReadingList &&
                            <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                                <div className='w-[170px] mr-2'>
                                    <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Acknowledged</p>
                                    <div className='flex items-center'>
                                        <div className='p-[8px] mr-7 flex items-center checkboxFocusAllignment mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                            <input
                                                type='checkbox'
                                                id='ack_yes'
                                                onChange={(e) => handleCheckboxChange(e, 'ne:__NULL__')}
                                                checked={deviceDashboardSearch?.acknowledged_id?.includes('ne:__NULL__')}
                                                className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            />
                                            <label htmlFor='ack_yes' className='text-xs font-normal text-[#000] cursor-pointer'>
                                                Yes
                                            </label>
                                        </div>
                                        <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                            <input
                                                type='checkbox'
                                                id='ack_no'
                                                onChange={(e) => handleCheckboxChange(e, '__NULL__')}
                                                checked={deviceDashboardSearch?.acknowledged_id?.includes('__NULL__')}
                                                className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            />
                                            <label htmlFor='ack_no' className='text-xs font-normal text-[#000] cursor-pointer'>
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className='relative w-[65px] mt-[20px]'>
                                    <div className='p-[8px] flex items-center mark-check mark-check1 mark-check2 relative checkbox custom-checkBoxBlue1'>
                                        <input
                                            type='checkbox'
                                            id='acknowledged_inverse'
                                            onChange={(e) => handleCheckboxChange(e, 'acknowledged_id_inverse')}
                                            checked={deviceDashboardSearch?.acknowledged_id_inverse === 'true'}
                                            className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                            disabled={deviceDashboardSearch?.acknowledged_id?.length === 0}
                                        />
                                        <label htmlFor='acknowledged_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        ref={btnRef}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent default form submission
                                handleClearAll();
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
